import { createAction } from '@reduxjs/toolkit';

export const setCache = createAction('cache/set');
export const deleteCache = createAction('cache/delete');
export const clearCache  = createAction('cache/clear');
